import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../App/API/api";

export const fetchShowProject = createAsyncThunk(
    "project/showProject",
    async (id, { rejectWithValue }) => {
        try {
            const response = await api.get(`/projects/${id}`);
            return response.data.data;
        } catch (error) {
            console.error("API Error:", error);
            return rejectWithValue(error.response?.data || error.message);
        }   
    }
);
  
const showProjectSlice = createSlice({
    name: "showProject",
    initialState: {
        loading: false,
        error: null,
        project: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchShowProject.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchShowProject.fulfilled, (state, action) => {
                state.loading = false;
                state.project = action.payload;
            })
            .addCase(fetchShowProject.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;       
            })
    },
});

export default showProjectSlice.reducer;